export default __webpack_public_path__ + "static/media/electric-stove.91aba4f1.svg";